import { Antecedentes_previos } from "../../../models/antecedentesPrevios.model";
import { ChangeDetectorRef, Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { FormService } from "src/app/services/form.service";
import * as moment from "moment";
import { LocalStorageService } from "src/app/services/local-storage.service";

@Component({
  selector: "app-antecedentes-previos",
  templateUrl: "./antecedentes-previos.component.html",
  styleUrls: ["./antecedentes-previos.component.css"],
})
export class AntecedentesPreviosComponent {
  public rows = [];
  public actualRow;
  public antecedentesPrevios: Antecedentes_previos;
  public form;
  public matcher = new FormService();
  public formNumber;
  public formulario;

  public fecha;
  public tipo_alt;
  public tipo_rec;

  public form111 = false;
  public form112 = false;
  public form113 = false;
  public form114 = false;
  public form115 = false;

  public form131 = false;
  public form132 = false;
  public form133 = false;

  public form151 = false;
  public form152 = false;
  public form153 = false;
  public form154 = false;

  public form231 = false;
  public form232 = false;

  public form212 = false;
  public form213 = false;
  public form214 = false;

  public form251 = false;
  public form252 = false;
  public form253 = false;
  public form254 = false;
  public form255 = false;

  public form271 = false;
  public form272 = false;
  public form273 = false;
  public form274 = false;
  public form275 = false;

  //tabla para los cips
  public rowscip = [];

  constructor(private cdr: ChangeDetectorRef) {
    this.formulario = localStorage.getItem("form");

    if (this.formulario == "1-1.1") {
      this.form111 = true;
    }
    if (this.formulario == "1-1.2") {
      this.form112 = true;
    }
    if (this.formulario == "1-1.3") {
      this.form113 = true;
    }
    if (this.formulario == "1-1.4") {
      this.form114 = true;
    }
    if (this.formulario == "1-1.5") {
      this.form115 = true;
    }

    if (this.formulario == "1-3.1") {
      this.form131 = true;
    }
    if (this.formulario == "1-3.2") {
      this.form132 = true;
    }
    if (this.formulario == "1-3.3") {
      this.form133 = true;
    }
    if (this.formulario == "1-5.1") {
      this.form151 = true;
    }
    if (this.formulario == "1-5.2") {
      this.form152 = true;
    }
    if (this.formulario == "1-5.3") {
      this.form153 = true;
    }
    if (this.formulario == "1-5.4") {
      this.form154 = true;
    }

    if (this.formulario == "2-3.1") {
      this.form231 = true;
    }
    if (this.formulario == "2-3.2") {
      this.form232 = true;
    }

    if (this.formulario == "2-1.2") {
      this.form212 = true;
    }
    if (this.formulario == "2-1.3") {
      this.form213 = true;
    }
    if (this.formulario == "2-1.4") {
      this.form214 = true;
    }

    if (this.formulario == "2-5.1") {
      this.form251 = true;
    }
    if (this.formulario == "2-5.2") {
      this.form252 = true;
    }
    if (this.formulario == "2-5.3") {
      this.form253 = true;
    }
    if (this.formulario == "2-5.4") {
      this.form254 = true;
    }
    if (this.formulario == "2-5.5") {
      this.form255 = true;
    }

    if (this.formulario == "2-7.1") {
      this.form271 = true;
    }
    if (this.formulario == "2-7.2") {
      this.form272 = true;
    }
    if (this.formulario == "2-7.3") {
      this.form273 = true;
    }
    if (this.formulario == "2-7.4") {
      this.form274 = true;
    }
    if (this.formulario == "2-7.5") {
      this.form275 = true;
    }

    this.form = new FormGroup({
      datosExtrasAntecedentes: new FormControl(""),
      nombreProyecto: new FormControl(""),
      numeroProyecto: new FormControl("", [Validators.pattern(/^[0-9]\d*$/)]),
      fechaProyecto: new FormControl(""),
      cipPermisoNumeroProyecto: new FormControl("", [
        Validators.pattern(/^[0-9]\d*$/), Validators.required
      ]),
      cipPermisoFechaProyecto: new FormControl("", Validators.required),
      permisoNumeroProyecto: new FormControl(""),
      permisoFechaProyecto: new FormControl(""),
      superficieModificacion: new FormControl(""),
      superficieModificada: new FormControl(""),
    });
    if (!JSON.parse(localStorage.getItem("materiaAnexa"))) {
      localStorage.setItem(
        "materiaAnexa",
        JSON.stringify(this.form.value.datosExtrasAntecedentes)
          ? JSON.stringify(this.form.value.datosExtrasAntecedentes)
          : ""
      );
    }

    if (!JSON.parse(localStorage.getItem("antecedentesPrevios"))) {
      localStorage.setItem("antecedentesPrevios", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("antecedentesPrevios"));
      this.form.controls["datosExtrasAntecedentes"].setValue(
        this.rows[0] ? this.rows[0].datosExtrasAntecedentes : ""
      );
      this.form.controls["nombreProyecto"].setValue(
        this.rows[0] ? this.rows[0].nombreProyecto : ""
      );
      this.form.controls["numeroProyecto"].setValue(
        this.rows[0] ? this.rows[0].numeroProyecto : ""
      );
      this.form.controls["fechaProyecto"].setValue(
        this.rows[0] ? this.rows[0].fechaProyecto : ""
      );
      this.form.controls["cipPermisoNumeroProyecto"].setValue(
        this.rows[0] ? this.rows[0].cipPermisoNumeroProyecto : ""
      );
      this.form.controls["cipPermisoFechaProyecto"].setValue(
        this.rows[0] ? this.rows[0].cipPermisoFechaProyecto : ""
      );
      this.form.controls["permisoNumeroProyecto"].setValue(
        this.rows[0] ? this.rows[0].permisoNumeroProyecto : ""
      );
      this.form.controls["permisoFechaProyecto"].setValue(
        this.rows[0] ? this.rows[0].permisoFechaProyecto : ""
      );
      this.form.controls["superficieModificacion"].setValue(
        this.rows[0] ? this.rows[0].superficieModificacion : ""
      );
      this.form.controls["superficieModificada"].setValue(
        this.rows[0] ? this.rows[0].superficieModificada : ""
      );
    }
    this.antecedentesPrevios = {
      datosExtrasAntecedentes: "",
      nombreProyecto: "",
      numeroProyecto: "",
      fechaProyecto: "",
      cipPermisoNumeroProyecto: "",
      cipPermisoFechaProyecto: "",
      permisoNumeroProyecto: "",
      permisoFechaProyecto: "",
      superficieModificacion: "",
      superficieModificada: "",
    };
  }

  intervalId: any;

  ngOnInit() {
    // Cargar los datos iniciales
    this.loadFromLocalStorage();

    // Revisar periódicamente cambios en el localStorage
    this.intervalId = setInterval(() => {
      this.loadFromLocalStorage();
    }, 1000); // Revisa cada segundo
  }

  ngOnDestroy() {
    // Limpiar el intervalo cuando el componente se destruye
    clearInterval(this.intervalId);
  }

  loadFromLocalStorage() {
    const storedData = JSON.parse(localStorage.getItem('antecedentesPrevios'));
    if (storedData && storedData.length > 0) {
      //this.add_antecedentesPrevios()
      this.rows = storedData;
      this.cdr.detectChanges();
      this.form.controls["datosExtrasAntecedentes"].setValue(
        this.rows[0] ? this.rows[0].datosExtrasAntecedentes : ""
      );

    }
  }

  add_antecedentesPrevios(btn?) {
    if (btn == "btn") {
      this.actualRow = localStorage.getItem("antecedentesPrevios");
      this.rows = JSON.parse(this.actualRow);
      let fechaFormat = this.form.value.fechaProyecto
        ? moment(this.form.value.fechaProyecto).format("DD/MM/YYYY")
        : "";
      if (this.rows[0] && this.rows[0].numeroProyecto == "") {
        this.rows[0].numeroProyecto = this.form.value.numeroProyecto;
        this.rows[0].fechaProyecto = fechaFormat;

        localStorage.setItem("antecedentesPrevios", JSON.stringify(this.rows));
        // limpiar los campos del formulario
        this.form.patchValue({
          numeroProyecto: null,
          fechaProyecto: null,
        });
      } else {
        // localStorage.setItem("antecedentesPrevios", JSON.stringify([]));
        this.rows.push({
          datosExtrasAntecedentes: this.form.value.datosExtrasAntecedentes,
          nombreProyecto: this.form.value.nombreProyecto,
          numeroProyecto: this.form.value.numeroProyecto,
          fechaProyecto: fechaFormat,
          cipPermisoNumeroProyecto: this.form.value.cipPermisoNumeroProyecto,
          cipPermisoFechaProyecto: this.form.value.cipPermisoFechaProyecto
            ? moment(this.form.value.cipPermisoFechaProyecto).format(
              "DD/MM/YYYY"
            )
            : "",
          permisoNumeroProyecto: this.form.value.permisoNumeroProyecto,
          permisoFechaProyecto: this.form.value.permisoFechaProyecto
            ? moment(this.form.value.permisoFechaProyecto).format("DD/MM/YYYY")
            : "",
          superficieModificacion: this.form.value.superficieModificacion,
          superficieModificada: this.form.value.superficieModificada,
        });
        localStorage.setItem("antecedentesPrevios", JSON.stringify(this.rows));
        this.form.controls["numeroProyecto"].setValue("");
        this.form.controls["fechaProyecto"].setValue("");
      }
    } else {
      // this.actualRow = localStorage.getItem("antecedentesPrevios");
      // this.rows = JSON.parse(this.actualRow);

      if (this.rows[0]) {
        this.actualRow = localStorage.getItem("antecedentesPrevios");
        this.rows = JSON.parse(this.actualRow);
        this.rows[0].datosExtrasAntecedentes =
          this.form.value.datosExtrasAntecedentes;
        this.rows[0].nombreProyecto = this.form.value.nombreProyecto;
        this.rows[0].numeroProyecto = this.rows[0]
          ? this.rows[0].numeroProyecto
          : "";
        this.rows[0].fechaProyecto = this.rows[0]
          ? this.rows[0].fechaProyecto
          : "";
        this.rows[0].cipPermisoNumeroProyecto =
          this.form.value.cipPermisoNumeroProyecto;
        this.rows[0].cipPermisoFechaProyecto = this.form.value
          .cipPermisoFechaProyecto
          ? moment(this.form.value.cipPermisoFechaProyecto).format("DD/MM/YYYY")
          : "";
        this.rows[0].permisoNumeroProyecto =
          this.form.value.permisoNumeroProyecto;
        this.rows[0].permisoFechaProyecto = this.form.value.permisoFechaProyecto
          ? moment(this.form.value.permisoFechaProyecto).format("DD/MM/YYYY")
          : "";
        this.rows[0].superficieModificacion =
          this.form.value.superficieModificacion;
        this.rows[0].superficieModificada =
          this.form.value.superficieModificada;

        localStorage.setItem("antecedentesPrevios", JSON.stringify(this.rows));
      } else {
        console.log("ultimo else", this.rows);

        this.rows = [
          {
            datosExtrasAntecedentes: this.form.value.datosExtrasAntecedentes,
            nombreProyecto: this.form.value.nombreProyecto,
            cipPermisoNumeroProyecto: this.form.value.cipPermisoNumeroProyecto,
            cipPermisoFechaProyecto: this.form.value.cipPermisoFechaProyecto
              ? moment(this.form.value.cipPermisoFechaProyecto).format(
                "DD/MM/YYYY"
              )
              : "",
            permisoNumeroProyecto: this.form.value.permisoNumeroProyecto,
            permisoFechaProyecto: this.form.value.permisoFechaProyecto
              ? moment(this.form.value.permisoFechaProyecto).format(
                "DD/MM/YYYY"
              )
              : "",
            superficieModificacion: this.form.value.superficieModificacion,
            superficieModificada: this.form.value.superficieModificada,
            numeroProyecto: "",
            fechaProyecto: "",
          },
        ];
        localStorage.setItem("antecedentesPrevios", JSON.stringify(this.rows));
      }
    }
  }

  onNgModelChangeAlt(event) {
    if (
      this.form.value.numeroProyecto != "" ||
      this.form.value.fechaProyecto != ""
    ) {
      this.tipo_alt = event;
      this.add_antecedentesPrevios();
    }
  }

  deleteCip(row) {
    let rowsAux = [];
    this.rows.map((data) => {
      if (data.numeroProyecto != row.numeroProyecto) {
        rowsAux.push(data);
      }
    });
    this.rows = rowsAux;
    localStorage.setItem("antecedentesPrevios", JSON.stringify(this.rows));
  }
}
